import { motion } from "framer-motion";
import { WHY_US } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

const CRAFT_IMG =
  "https://images.unsplash.com/photo-1704005445445-2747074be8ac?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export const WhyChooseUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-charcoal py-24 sm:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="text-brick-light font-bold text-sm tracking-[0.18em] uppercase">Why BBS Masonry</span>
              <h2 className="mt-3 font-heading font-extrabold tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.03]">
                Craftsmanship you can stand behind.
              </h2>
              <p className="mt-5 text-white/60 text-base sm:text-lg leading-relaxed">
                We're a family-owned company built on doing honest work the right way — the reason West Michigan
                homeowners have trusted us for over 30 years.
              </p>
              <div className="mt-8 rounded-2xl overflow-hidden border border-white/10">
                <img src={CRAFT_IMG} alt="Mason at work laying brick" loading="lazy" className="w-full h-64 object-cover" />
              </div>
            </Reveal>
          </div>

          <div className="flex flex-col">
            {WHY_US.map((item, i) => (
              <Reveal key={item.n} delay={(i % 2) * 0.05}>
                <motion.div className="group flex gap-6 py-7 border-b border-white/10">
                  <span className="font-heading font-extrabold text-5xl sm:text-6xl text-white/10 group-hover:text-brick-light transition-colors duration-300 leading-none">
                    {item.n}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-heading font-bold text-white text-xl sm:text-2xl">{item.title}</h3>
                    <p className="mt-2 text-white/55 text-base leading-relaxed">{item.desc}</p>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
